import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import getFetchStoreLocationsOptions from './get-options';
var useFetchStoreLocations = function useFetchStoreLocations(_ref) {
  var anchor = _ref.anchor,
    count = _ref.count,
    maxDistance = _ref.maxDistance,
    longitude = _ref.longitude,
    latitude = _ref.latitude,
    postalCode = _ref.postalCode,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    select = _ref.select;
  return useQuery(_objectSpread(_objectSpread({
    enabled: Boolean(longitude && latitude) || Boolean(postalCode) && enabled
  }, select && {
    select: select
  }), getFetchStoreLocationsOptions({
    anchor: anchor,
    count: count,
    maxDistance: maxDistance,
    longitude: longitude,
    latitude: latitude,
    postalCode: postalCode
  })));
};
export default useFetchStoreLocations;